"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userTypeTitle = exports.userTypeDeserialize = exports.userTypeMobileApp = exports.userTypeAllKnown = void 0;
const sentenceCase_1 = __importDefault(require("../util/sentenceCase"));
const stringEnumDeserialize_1 = __importDefault(require("./stringEnumDeserialize"));
const tupleForUnionType_1 = require("./tupleForUnionType");
exports.userTypeAllKnown = (0, tupleForUnionType_1.tupleForUnionType)({
    ADMIN: undefined,
    CUSTOMER: undefined,
    DRIVER: undefined,
    GUARDIAN: undefined,
    ORDERER: undefined,
    RESTAURANT: undefined,
});
exports.userTypeMobileApp = ['CUSTOMER', 'DRIVER'];
exports.userTypeDeserialize = (0, stringEnumDeserialize_1.default)(exports.userTypeAllKnown, 'user type', true);
function userTypeTitle(type) {
    switch (type) {
        case 'ADMIN':
            return 'Admin';
        case 'CUSTOMER':
            return 'Rider';
        case 'DRIVER':
            return 'Driver';
        case 'GUARDIAN':
            return 'Guardian';
        case 'ORDERER':
            return 'Orderer';
        case 'RESTAURANT':
            return 'Restaurant';
        default:
            return (0, sentenceCase_1.default)(type);
    }
}
exports.userTypeTitle = userTypeTitle;
